module.exports = __webpack_public_path__ + "frontend/images/favicons/favicon-32x32.png?fe5c307c65d1e28072c44562678001f1";